// React
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, Navigate, useNavigate } from 'react-router-dom';
// コンポーネント
import Google from '../../../components/button/SocialLogin/Google';
// ユーティリティ
import { menu } from '../../../constants';
import { firebaseConfiguration } from '../../../settings';
import { useAuth } from '../../../context/AuthContext';
import { validationSchema } from '../../../utils/validationUtils';
import { errorMessages } from '../../../utils/messagesUtils';

import sty from './Signin.module.css';

const LoginEn = () => {
  const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(false);
  const { setLoginUser, setRole } = useAuth();
  const { register, handleSubmit, formState: { errors } } = useForm({
    mode: 'onBlur', // フォーカスが外れたときにバリデーションを実行
  })

  // ログイン済みか確認
  const [previouslyLoggedIn, setPreviouslyLoggedIn] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/check-whether-previously-logged-in-or-not-as-engineer`, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate'
          },
          credentials: 'include',
          cache: 'no-store'
        });
        const data = await response.json()
        if (response.status === 200 && data.status === 'OK') {
          setPreviouslyLoggedIn(true)
        } else {
          setPreviouslyLoggedIn(false)
        }
      } catch (e) {
        // network failure
        setPreviouslyLoggedIn(false)
      }
    })()
  }, [])

  // パスワード表示・非表示
  const [passwordVisible, setPasswordVisible] = useState(false)
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible)
  }

  // エラーメッセージ表示
  const [errorFromServer, setErrorFromServer] = useState('')

  // ログイン処理
  const onSubmit = async (data) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/signin`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate'
        },
        body: JSON.stringify(data),
        credentials: 'include',
        cache: 'no-store'
      })
      const result = await response.json()
      if (response.status === 200 && result.status === 'OK') { 
          // Auth Context にログインユーザーとロールを設定
          localStorage.setItem('userId', result.data.userId);
          setLoginUser(result.data.name)
          setRole(result.data.role)
          navigate(menu.ENGINEER.HOME.PATH)
      }else{
        if (response.status === 429) {
          const error = new Error();
          error.front_message = errorMessages.login.too_many_attempts;
          throw error;
        } else if (response.status === 401) { 
          const error = new Error();
          error.front_message = errorMessages.login.invalid_credentials;
          throw error;
        } else {
          // 上記以外のエラー
          const error = new Error();
          error.front_message = errorMessages.login.login_failed;
          throw error;
        }
      }
    } catch (e) {
      setErrorFromServer(e.front_message || errorMessages.login.login_failed)
    }
  }

  if (previouslyLoggedIn) {
    return <Navigate to={menu.ENGINEER.HOME.PATH} replace={true} />
  } else {
    return (
      !previouslyLoggedIn &&
      <>
      <form onSubmit={handleSubmit(onSubmit)} className="bg">
        <div className="account-container">
          <div className="page-tit">
            <div className="page-tit-outer">
              <p className="page-tit-txt">ログイン</p>
              <div className="page-tit-border"></div>
            </div>
          </div>
          <div className="inner-container">
            {errorFromServer && <p className='account-error-msg'>{errorFromServer}</p>}
            <div className={sty['login__mail']}>
              <div className={sty['login__mail-mail-tit']}>
                <label htmlFor="email">メールアドレス</label>
              </div>
              <div className={sty['login__mail-mail-tit']}>
                <input {...register('email', validationSchema.email)} type="email" className={sty['login__email-input']} id="email" autoComplete="email" placeholder="taro.yamada@example.com" />
                {errors.email && <p className="form__validation-msg"
                >{errors.email.message}</p>}
              </div>
            </div>

            <div className={sty['login__pass']}>
              <div className={sty['login__pass-pass-tit']}>
                <label htmlFor="password">パスワード</label>
              </div>
              <div className={sty['login__pass-pass-tit']}>
                <div className={sty['login__pass-pass-ex']}>
                  <input {...register('password', validationSchema.password)} type={passwordVisible ? 'text' : 'password'}
                    className={sty['login__pass-input-field']} placeholder="パスワードを入力してください" id="password" />
                  {errors.password && <p className="form__validation-msg">{errors.password.message}</p>}
                  <img src={passwordVisible ? '/images/open.svg' : '/images/hidden.svg'}
                    alt="パスワード表示・非表示" 
                    className={`${sty['login__pass-toggle']} ${passwordVisible ? sty['login__pass-toggle--open'] : ''}`}
                    onClick={togglePasswordVisibility} />
                </div>
                <div className={sty['login__pass-forgot']}>
                  <Link to="/forgot-password" state={{ role: 2 }}>パスワードをお忘れの方</Link>
                </div>
              </div>
            </div>
            <div className="primary-btns">
              <button type="submit" className="primary-btn btn-large" disabled={isDisabled}>ログイン</button>
              <div className="link__under-btn">
                <Link to="/signup">アカウント登録はこちら</Link>
              </div>
            </div>
          </div>
          <Google 
            fc={firebaseConfiguration} 
            homePage={menu.ENGINEER.HOME.PATH}
            isDisabled={isDisabled}
            setDisabled={setIsDisabled}
          />
        </div>
      </form >
      </>
    )
  }
}

export default LoginEn;


